import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import addPV from "utils/add-pv.js";
import styles from "./PageLink.module.scss";

const PageLink = props => {
  const link = props.data[0];
  let trackingConfig = {};

  if (props.trackingType === "trackPageView") {
    trackingConfig = {
      url: `count/feature/${props.currentSlug}/getstarted${props.linkIndex}`,
      path: link.href,
      openInNewTab: link.openInNewTab
    };
  }

  if (props.trackingType === "trackEvent") {
    trackingConfig = {
      path: link.href,
      ...props.trackingConfig
    };
  }

  return (
    <a
      href={link.href}
      target={link.openInNewTab ? "_blank" : null}
      className={classnames(styles.pageLink, props.className)}
      onClick={e => {
        props.onClick && !link.href
          ? props.onClick(e)
          : addPV(e, props.trackingType, trackingConfig);
      }}
    >
      {link.text}
    </a>
  );
};

PageLink.defaultProps = {
  trackingType: "trackPageView"
};

PageLink.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  trackingType: PropTypes.string.isRequired,
  trackingConfig: PropTypes.object,
  currentSlug: PropTypes.string,
  linkIndex: PropTypes.number,
  className: PropTypes.string
};

export default PageLink;
